import { useState, useEffect } from 'react';
import SauvojenTsekkaus from './scene_03_sauvojenTsekkaus';
import ApvTaustoitus from './scene_03_apv_taustoitus'
import TupenVaihto from './scene_03_tupen_vaihto'
import SauvojenPituus from './scene_03_sauvojen_pituus';
import SauvatMatalaPlusplus from './scene_03_sauvat_matala_plusplus'
import SauvatMatalaPlus from './scene_03_sauvat_matala_plus'
import SauvatKorkeaPlus from './scene_03_sauvat_korkea_plus'
import SauvatSopivat from './scene_03_sauvat_sopivat'

import WTW from './scene_03_walk_this_way';
import WalkOk from './scene_03_walk_ok.js';
import StairsUpOk from './scene_03_stairs_up_ok.js';
import StairsUp from './scene_03_stairs_up.js';
import StairsDown from './scene_03_stairs_down.js';




const Scenepohja_03 = ({ scoreHandler_main, visibilityHandler_main, soundsOn }) => {


    //eka scene näkyviin oletuksena
    const [visibleApvTaustoitus, setVisibleApvTaustoitus] = useState(true)
    const [visibleSauvojenTsekkaus, setVisibleSauvojenTsekkaus] = useState(false)
    const [visibleTupenVaihto, setVisibleTupenVaihto] = useState(false)
    // const [visibleTuppeaEiVaihdettu, setVisibleTuppeaEiVaihdettu] = useState(false)
    const [visibleSauvojenPituus, setVisibleSauvojenPituus] = useState(false)

    const [visibleSauvatSopivat, setVisibleSauvatSopivat] = useState(false)

    const [visibleSauvatMatalaPlusplus, setVisibleSauvatMatalaPlusplus] = useState(false)
    const [visibleSauvatMatalaPlus, setVisibleSauvatMatalaPlus] = useState(false)
    const [visibleSauvatKorkeaPlus, setVisibleSauvatKorkeaPlus] = useState(false)



    const [visibleWalkOk, setVisibleWalkOk] = useState(false)
    const [visibleWTW, setVisibleWTW] = useState(false)
    const [visibleStairsUp, setVisibleStairsUp] = useState(false)
    const [visibleStairsUpOk, setVisibleStairsUpOk] = useState(false)
    const [visibleStairsDown, setVisibleStairsDown] = useState(false)


    const [yritysLkm, setYritysLkm] = useState(0)

    function AddTrial() {
        setYritysLkm(yritysLkm + 1)

    }

    const hideAllScenes = () => {

        setVisibleApvTaustoitus(false)
        setVisibleSauvojenTsekkaus(false)
        setVisibleTupenVaihto(false)
        setVisibleSauvojenPituus(false)
        setVisibleSauvatSopivat(false)
        setVisibleSauvatMatalaPlusplus(false)
        setVisibleSauvatMatalaPlus(false)
        setVisibleSauvatKorkeaPlus(false)
        setVisibleWTW(false)
        setVisibleWalkOk(false)
        setVisibleStairsUp(false)
        setVisibleStairsUpOk(false)
        setVisibleStairsDown(false)


    }

    const visibilityHandler = (valinta) => {

        hideAllScenes()

        switch (valinta) {
            case "jatka sauvojen tsekkaukseen":
                setVisibleSauvojenTsekkaus(true)
                break;
            case "A sauvoissa fiksattavaa":
                setVisibleTupenVaihto(true)
                break;
            case "B sauvat ok":
                setVisibleSauvojenPituus(true)
                break;
            case "Säädetään uudelleen":
                setVisibleSauvojenPituus(true)
                break;
            case "tuppi vaihdettu":
                setVisibleSauvojenPituus(true)
                break;
            case "sauvat sopivat":
                setVisibleSauvatSopivat(true)
                break;
            case "sauvat matala plusplus":
                setVisibleSauvatMatalaPlusplus(true)
                break;
            case "sauvat matala plus":
                setVisibleSauvatMatalaPlus(true)
                break;
            case "sauvat korkea plus":
                setVisibleSauvatKorkeaPlus(true)
                break;
            case "kävelytekniikkaan - wtw":
                setVisibleWTW(true)
                break;
            case "kävelytekniikka ok":
                setVisibleWalkOk(true)
                break;
            case "jatka portaisiin":
                setVisibleStairsUp(true)
                break;
            case "portaat ylös ok":
                // setVisibleStairsDown(true)
                setVisibleStairsUpOk(true)
                break;
            case "jatka portaat alas":
                setVisibleStairsDown(true)

                break;


        }

    }



    return (

        <div className='scenepohjaContainer'>

            {
                visibleApvTaustoitus ? <ApvTaustoitus scoreHandler={scoreHandler_main} visibilityHandler={visibilityHandler} soundsOn={soundsOn} /> : null
            }
            {
                visibleSauvojenTsekkaus ? <SauvojenTsekkaus scoreHandler={scoreHandler_main} visibilityHandler={visibilityHandler} soundsOn={soundsOn} /> : null
            }
            {
                visibleTupenVaihto ? <TupenVaihto scoreHandler={scoreHandler_main} visibilityHandler={visibilityHandler} soundsOn={soundsOn} /> : null
            }
            {
                visibleSauvojenPituus ? <SauvojenPituus scoreHandler={scoreHandler_main} visibilityHandler={visibilityHandler} soundsOn={soundsOn} /> : null
            }

            {
                visibleSauvatMatalaPlusplus ? <SauvatMatalaPlusplus visibilityHandler={visibilityHandler} soundsOn={soundsOn} /> : null
            }
            {
                visibleSauvatMatalaPlus ? <SauvatMatalaPlus visibilityHandler={visibilityHandler} soundsOn={soundsOn} /> : null
            }
            {
                visibleSauvatKorkeaPlus ? <SauvatKorkeaPlus visibilityHandler={visibilityHandler} soundsOn={soundsOn} /> : null
            }
            {
                visibleSauvatSopivat ? <SauvatSopivat scoreHandler={scoreHandler_main} visibilityHandler={visibilityHandler} soundsOn={soundsOn} /> : null
            }
            {
                visibleWTW ? <WTW scoreHandler={scoreHandler_main} visibilityHandler={visibilityHandler} soundsOn={soundsOn} trials={yritysLkm} addTrial={AddTrial} /> : null
            }
            {
                visibleWalkOk ? <WalkOk scoreHandler={scoreHandler_main} visibilityHandler={visibilityHandler} soundsOn={soundsOn} /> : null
            }

            {
                visibleStairsUp ? <StairsUp visibilityHandler={visibilityHandler} soundsOn={soundsOn} /> : null
            }
            {
                visibleStairsUpOk ? <StairsUpOk visibilityHandler={visibilityHandler} soundsOn={soundsOn} /> : null
            }
            {
                visibleStairsDown ? <StairsDown scoreHandler={scoreHandler_main} visibilityHandler={visibilityHandler} soundsOn={soundsOn} /> : null
            }




        </div>



    )


}

export default Scenepohja_03